module.exports = __webpack_public_path__ + "img/dragon.b4da4fcf.png";